// src/pages/auth/Login/Login.jsx
import React from 'react';
import { Container, Paper, Box } from '@mui/material';
import LoginForm from '../../../components/forms/LoginForm';

const Login = () => {
  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          py: 3,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            width: '100%',
            maxWidth: 400,
            borderRadius: 2,
          }}
        >
          <LoginForm />
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;